import React, { Fragment, useState, useRef } from 'react';

import CreateTrplBtn from './CreateTrplBtn';
import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import TrplTextfield from '../../TrplControls/TrplTextfield';
import TrplSelect from '../../TrplControls/TrplSelect';
import FuzzyVal from './FuzzyVal';

import TrplErrorAlertIcon from './TrplErrorAlertIcon';
import InfoAlert from './InfoAlert';

import { onlyUnique } from '../../../utils';
import MandatoryAlertIcon from './MandatoryAlertIcon';

const TextTrplControl = ({
  rst,
  trpl,
  item,
  type,
  formId,
  trplId,
  classes,
  groupId,
  setTrpl,
  constant,
  isNewNode,
  isInteger,
  trplIndex,
  tidsChain,
  ancestorId,
  loadingTids,
  deletedTids,
  selectClasses,
  hideSetDelete,
  isAnotherNode,
  onRstValueEdit,
  trplInputProps,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  textAreaClassName,
  showMandatoryAlert,
  disableTrplEditing,
  resetDeletedTrplId,
  getAutocompleteTrpls,
  disabledDefaultField,
  onChangeTextereaHeight,
  updateDataOnRestoreTrpl,
}) => {
  let [selectedElement, setSelectedElement] = useState(null);
  const [autocompleteTrpls, setAutocompleteTrpls] = useState([]);
  const ref = useRef(null);

  const resetAutocompleteTrpls = () => {
    setAutocompleteTrpls([]);
  };

  const disabledAutocomplete = item && (item.autocomplete === false || !item.autocomplete);
  const defaultUnit = rst.units && rst.units.find(unit => unit.default === true);

  const setAutocompleteData = (value) => {
    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;
    if (rst.type === 'STRING' && !disabledAutocomplete) {
      getAutocompleteTrpls(rstId, value, (data) => {
        if (data.trpls && data.trpls[rstId]) {
          // if single trpl = make it array
          const trpls = data.trpls[rstId];

          const trplValues = trpls.map(trpl => trpl.val);

          const uniqTrpls = trplValues.filter(onlyUnique);
          const slicedTrpls = uniqTrpls.length > 7 ? uniqTrpls.slice(0, 7) : uniqTrpls;

          setAutocompleteTrpls(slicedTrpls);
        } else {
          resetAutocompleteTrpls();
        }
      });
    }
  };

  const setTextTrpl = (value, disableReq) => {
    onRstValueEdit(rst, value, trplIndex, ancestorId, tidsChain);
    if (!disableReq) {
      setAutocompleteData(value);
    }
  };

  const onKeyDownHandler = (e) => {
    const { key } = e;

    // escape key
    if (key === 'Escape') {
      e.stopPropagation();

      resetAutocompleteTrpls();
      setSelectedElement(null);
    }

    // top arrow key
    if (key === 'ArrowUp') {
      if (selectedElement === 0) {
        setSelectedElement(null);
      }

      if (selectedElement !== null) {
        setSelectedElement((selectedElement -= 1));
      }
    }

    // down arrow key
    if (key === 'ArrowDown') {
      if (selectedElement === autocompleteTrpls.length - 1) return;
      if (selectedElement === null) {
        setSelectedElement(0);
      } else {
        setSelectedElement((selectedElement += 1));
      }
    }

    // enter key
    if (key === 'Enter' && selectedElement !== null) {
      setTextTrpl(autocompleteTrpls[selectedElement], true);
      resetAutocompleteTrpls();
      setSelectedElement(null);
    }
  };

  const isTextarea = rst.type === 'TEXTAREA';

  let elementKey;
  if (rst) elementKey = "f." + rst.id;
  if (formId) elementKey = "f" + formId  + "." + rst.id;

  const savedHeight = localStorage.getItem(`${elementKey}`);
  let textareaHeight = savedHeight ? parseInt(savedHeight, 10) : 90;

  return (
    <Fragment>
      {autocompleteTrpls && autocompleteTrpls.length ? (
        <div
          className={classes.fixedOverlay}
          style={{
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            zIndex: '10',
            position: 'fixed',
            background: 'transparent',
          }}
          onClick={() => setAutocompleteTrpls([])}
        />
      ) : null}

      <div key={`${rst.title} + ${trplIndex}`} className={`${classes.relative} ${classes.alignCenter} ${trplIndex === 0 ? '' : classes.mt5}`}>
        <div
          className={`${classes.fuzzy_parent} ${classes.fw} ${classes.relative} ${classes.alignCenter} ${!trpl.tid && trpl.unsaved ? classes.unsavedNewTrpl : ''}`}
        >
          {isTextarea ? (
            <textarea
              id={elementKey}
              ref={ref}
              disabled={disableTrplEditing}
              readOnly={disabledDefaultField || constant}
              value={trpl && trpl.hasOwnProperty('val') && trpl.val !== null ? trpl.val : ''}
              onChange={(e) => {
                setTextTrpl(e.target.value);
              }}
              className={`${classes.fuzzy_parent} ${classes.resizableTextarea} ${textAreaClassName}`}
              onMouseMoveCapture={() => {
                onChangeTextereaHeight(ref, elementKey);
              }}
              style={{
                position: 'relative',
                height: `${textareaHeight}px`,
                width: '100%',
                border: 'none',
                minHeight: '90px',
                maxHeight: '1000px',
                resize: 'vertical',
              }}
            />
          ) : (
            <TrplTextfield
              disabled={disabledDefaultField || constant || disableTrplEditing}
              fullWidth
              margin="none"
              multiline={isTextarea}
              InputProps={trplInputProps}
              rows={isTextarea ? 4 : 1}
              type={isInteger ? 'number' : 'text'}
              onKeyDown={(e) => {
                onKeyDownHandler(e);
              }}
              onChange={(e) => {
                setTextTrpl(e.target.value);
              }}
              value={trpl && trpl.hasOwnProperty('val') && trpl.val !== null ? trpl.val : ''}
            />
          )}

          {trpl.val_fuzzy ?
            <FuzzyVal
              top={'-9px'}
              right={'-3px'}
              classes={classes}
              value={trpl.val_fuzzy}
              //show={!trpl.hasOwnProperty('val') || trpl.val === '' || !trpl.val}
            />
          : null}

          {rst.units && rst.units.length ?
            <div className={`${classes.alignCenter} ${classes.ml5}`}>
              <TrplSelect
                disabled={disabledDefaultField || constant || disableTrplEditing}
                margin="none"
                placeholder={"Units"}
                selectClasses={selectClasses}
                values={rst.units.map(unit => unit.id)}
                value={trpl.hasOwnProperty("units") ? trpl.units : !trpl.tid && defaultUnit ? defaultUnit.id : ''}
                onChange={(e) => {
                  onRstValueEdit(rst, e.target.value, trplIndex, ancestorId, tidsChain, 'units');
                }}
              />
            </div>
          : null}

          <TrplErrorAlertIcon trpl={trpl} />
          {!trpl.tid && showMandatoryAlert && <MandatoryAlertIcon />}
          {disabledDefaultField && <InfoAlert />}

          {autocompleteTrpls && autocompleteTrpls.length ? (
            <div className={classes.autocompleteContainer}>
              {autocompleteTrpls.map((autoTrpl, autoTrplIndex) => {
                return (
                  <div
                    key={autoTrplIndex}
                    style={{
                      background: `${selectedElement === autoTrplIndex ? '#fafafa' : ''}`,
                    }}
                    onClick={() => {
                      onRstValueEdit(rst, autoTrpl, trplIndex, ancestorId);

                      resetAutocompleteTrpls();
                      setSelectedElement(null);
                    }}
                    className={classes.autocompleteEl}
                  >
                    {autoTrpl}
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>

        {hideSetDelete ? null : (trpl && trpl.tid ?
          <SetDeleteTrplBtns
            rst={rst}
            type={type}
            trpl={trpl}
            classes={classes}
            groupId={groupId}
            setTrpl={setTrpl}
            trplIndex={trplIndex}
            ancestorId={ancestorId}
            loadingTids={loadingTids}
            isAnotherNode={isAnotherNode}
            setLoadingTids={setLoadingTids}
            removeTrplValue={removeTrplValue}
            setDeletedTrplId={setDeletedTrplId}
            constant={constant || disableTrplEditing}
          />
          :
          <CreateTrplBtn
            rst={rst}
            trpl={trpl}
            trplId={trplId}
            classes={classes}
            setTrpl={setTrpl}
            isNewNode={isNewNode}
            trplIndex={trplIndex}
            ancestorId={ancestorId}
            loadingTids={loadingTids}
            deletedTids={deletedTids}
            isAnotherNode={isAnotherNode}
            setLoadingTids={setLoadingTids}
            resetDeletedTrplId={resetDeletedTrplId}
            disableTrplEditing={disableTrplEditing}
            constant={disabledDefaultField || constant}
            updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
          />
        )}
      </div>
    </Fragment>
  );
};

export default TextTrplControl;
